import React, { useEffect, useState } from "react";

import { Loading } from "../../../components";
import ClassificacaoEstatisticaService from "../../../services/ClassificacaoEstatisticaService";

export default function ClassificationStatistic({ estatisticasClassificacao }) {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const [estatisticas, setEstatisticas] = useState(null);

  useEffect(() => {
    if (!estatisticasClassificacao) return setIsLoaded(true)

    const lastSearch = JSON.parse(sessionStorage.getItem('LastSearch-Estatisticas-classificacao'))

    if (lastSearch) {
      if (lastSearch.idFazenda === estatisticasClassificacao.idFazenda
        && lastSearch.idRaca === estatisticasClassificacao.idRaca
      ) {
        setEstatisticas({ ...lastSearch });
        setIsLoaded(true)
      } else {
        getTotal(estatisticasClassificacao);
      }
    } else {
      getTotal(estatisticasClassificacao);
    }
  }, []);

  const getTotal = async (value) => {
    const response = await ClassificacaoEstatisticaService.filterStatic(value)

    if (response) {
      if (response.isAxiosError) {
        setError(response.response.data.message || response.response.data || 'Erro ao tentar carregar lista!')
        setIsLoaded(true)
        return
      }
      setEstatisticas(response);
      LastSearch(response)
      setIsLoaded(true)
    } else {
      setIsLoaded(true)
      setError('Erro ao tentar carregar lista!')
    }
  };

  const LastSearch = (data) => {
    sessionStorage.setItem("LastSearch-Estatisticas-classificacao",
      JSON.stringify({
        ...data,
        idFazenda: estatisticasClassificacao.idFazenda,
        idRaca: estatisticasClassificacao.idRaca
      }))
  }

  if (error) {
    return <div className="error-list">Error: {error}</div>;
  } else if (!isLoaded) {
    return <Loading show={true} />;
  } else {
    return (
      <>
        {(isLoaded && !estatisticas) && (
          <h3 className="mt-4">Faça a consulta na aba filtro</h3>
        )}

        {estatisticas && estatisticas.valores.length > 0 && (
          <>
            <div className="table-horizontal">
              <div className="table-horizontal-header bg-primary">
                <h2 className="ff-roboto fs-22px">Estatistica da Consulta - MGTe</h2>

                <button className="global-btn-info">XLS</button>
              </div>
              <div className="table-filter__scroll">
                <div className="table-horizontal-body short">
                  <div className="table-horizontal-row-item-header py-0">
                    <div className="table-horizontal-row-item-header-item">
                      <span>TOP</span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span>Nº</span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span>%</span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span>Média</span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span>Mínimo</span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span>Máximo</span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span>Desvio Padrão</span>
                    </div>
                  </div>

                  {estatisticas.valores.map((result, index) => {
                    return (
                      <div
                        className="table-horizontal-row"
                        key={index}
                        style={{
                          background: index % 2 === 0 ? "#F7F7FA" : "#FFF",
                        }}
                      >
                        <div className="table-horizontal-row-item">
                          <span>{result.top}</span>
                        </div>
                        <div className="table-horizontal-row-item">
                          <span>{result.total}</span>
                        </div>
                        <div className="table-horizontal-row-item">
                          <span>{result.porcentagem}</span>
                        </div>
                        <div className="table-horizontal-row-item">
                          <span>{result.media}</span>
                        </div>
                        <div className="table-horizontal-row-item">
                          <span>{result.minimo}</span>
                        </div>
                        <div className="table-horizontal-row-item">
                          <span>{result.maximo}</span>
                        </div>
                        <div className="table-horizontal-row-item">
                          <span>{result.desvioPadrao}</span>
                        </div>
                      </div>
                    );
                  })}

                  <div className="table-horizontal-row-item-header shadow-none">
                    <div className="table-horizontal-row-item-header-item">
                      <span></span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span></span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span></span>
                    </div>
                    <div className="table-horizontal-row-item-header-item short">
                      <span>{estatisticas.mediaDestaque}</span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span></span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span></span>
                    </div>
                    <div className="table-horizontal-row-item-header-item">
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="btn-container">
              <a
                href="/submodulos/2"
                className="global-btn-info shadow-none text-decoration-none"
              >
                Voltar
              </a>
            </div>
          </>
        )}
      </>
    );
  }
}
